{
  "AUTOMATION": {
    "HEADER": "Автоматизація",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Додати правило автоматизації",
    "LOADING": "Отримання правил автоматизації",
    "ADD": {
      "TITLE": "Додати правило автоматизації",
      "SUBMIT": "Створити",
      "CANCEL_BUTTON_TEXT": "Скасувати",
      "FORM": {
        "NAME": {
          "LABEL": "Ім'я правила",
          "PLACEHOLDER": "Введіть назву правила",
          "ERROR": "Назва обов'язкова"
        },
        "DESC": {
          "LABEL": "Опис",
          "PLACEHOLDER": "Введіть опис правила",
          "ERROR": "Необхідний опис"
        },
        "EVENT": {
          "LABEL": "Івент",
          "PLACEHOLDER": "Будь ласка, виберіть",
          "ERROR": "Івент обов'язковий"
        },
        "CONDITIONS": {
          "LABEL": "Умови"
        },
        "ACTIONS": {
          "LABEL": "Дії"
        },
        "PHASE": {
          "LABEL": "Фаза"
        },
        "ORDER": {
          "LABEL": "Порядок",
          "ERROR": "Порядок є обов'язковим"
        }
      },
      "CONDITION_BUTTON_LABEL": "Додати умову",
      "ACTION_BUTTON_LABEL": "Додати дію",
      "API": {
        "SUCCESS_MESSAGE": "Правило автоматизації додано успішно",
        "ERROR_MESSAGE": "Не вдалося створити правило автоматизації, спробуйте ще раз пізніше"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Ім'я",
        "DESCRIPTION": "Опис",
        "ACTIVE": "Активний",
        "CREATED_ON": "Створено",
        "PHASE": "Фаза",
        "ORDER": "Порядок",
        "WAIT": "Очікування"
      },
      "404": "Не знайдено правил автоматизації",
      "TABS": {
        "ALL": "Усі",
        "INSTANT": "Під час події",
        "DELAYED": "Із затримкою"
      },
      "WAITS": "Чекає {duration}"
    },
    "DELETE": {
      "TITLE": "Видалити правило автоматизації",
      "SUBMIT": "Видалити",
      "CANCEL_BUTTON_TEXT": "Скасувати",
      "CONFIRM": {
        "TITLE": "Підтвердження видалення",
        "MESSAGE": "Справді бажаєте видалити ",
        "YES": "Так, видалити ",
        "NO": "Ні, залишити "
      },
      "API": {
        "SUCCESS_MESSAGE": "Правило автоматизації видалено успішно",
        "ERROR_MESSAGE": "Не вдалося видалити правило автоматизації, спробуйте ще раз пізніше"
      }
    },
    "EDIT": {
      "TITLE": "Редагувати правило автоматизації",
      "SUBMIT": "Оновити",
      "CANCEL_BUTTON_TEXT": "Скасувати",
      "API": {
        "SUCCESS_MESSAGE": "Правило автоматизації успішно оновлено",
        "ERROR_MESSAGE": "Не вдалося оновити правило автоматизації, спробуйте ще раз пізніше"
      }
    },
    "CLONE": {
      "TOOLTIP": "Копіювати",
      "API": {
        "SUCCESS_MESSAGE": "Автоматизацію успішно скопійовано",
        "ERROR_MESSAGE": "Не вдалося скопіювати правило автоматизації, будь ласка, спробуйте ще раз пізніше"
      }
    },
    "FORM": {
      "EDIT": "Редагувати",
      "CREATE": "Створити",
      "DELETE": "Видалити",
      "CANCEL": "Скасувати",
      "RESET_MESSAGE": "Зміна типу події скине умови та події, які ви додали нижче"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Ви повинні мати принаймні одну умову для збереження",
      "CONTACT_CUSTOM_ATTR_LABEL": "Атрибути контакту",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Атрибути бесіди"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Ви повинні мати принаймні одну дію для збереження",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Введіть ваше повідомлення тут",
      "TEAM_DROPDOWN_PLACEHOLDER": "Обрати команди",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Виберіть інбокс електронної пошти та адресу відправника",
      "SUBJECT_INPUT_PLACEHOLDER": "Тема листа",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Виберіть SMS-інбокс, з якого буде надіслано SMS",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Введіть текст SMS",
      "SMS_COUNTER": "{length}/{limit} символів, {segments} SMS (до підстановки змінних)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Активувати правило автоматизації",
      "DEACTIVATION_TITLE": "Вимкнути правило автоматизації",
      "ACTIVATION_DESCRIPTION": "Ця дія активує правило автоматизації '{automationName}. Ви впевнені, що хочете продовжити?",
      "DEACTIVATION_DESCRIPTION": "Ця дія деактивує правило автоматизації '{automationName}. Ви впевнені, що хочете продовжити?",
      "ACTIVATION_SUCCESFUL": "Правило автоматизації активоване успішно",
      "DEACTIVATION_SUCCESFUL": "Правило автоматизації успішно деактивовано",
      "ACTIVATION_ERROR": "Не вдалося активувати автоматизацію, спробуйте ще раз пізніше",
      "DEACTIVATION_ERROR": "Не вдалося деактивувати автоматизацію, спробуйте ще раз пізніше",
      "CONFIRMATION_LABEL": "Так",
      "CANCEL_LABEL": "Ні"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Не вдалося завантажити вкладення, будь ласка, спробуйте ще раз",
      "LABEL_IDLE": "Завантажити вкладення",
      "LABEL_UPLOADING": "Завантажується...",
      "LABEL_UPLOADED": "Успішно завантажено",
      "LABEL_UPLOAD_FAILED": "Не вдалося завантажити"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Необхідно вказати значення",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Значення має бути від 0 до 998",
      "ORDER_REQUIRED": "Порядок є обов'язковим",
      "ORDER_MUST_BE_AT_LEAST_ONE": "Порядок має бути щонайменше 1"
    },
    "NONE_OPTION": "Нiчого",
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Ця дія працює лише якщо для фази правила встановлено «До маркування».",
      "SKIP_AUTO_LABELING": "Ця дія працює лише якщо для фази правила встановлено «До маркування».",
      "MOVE_CONVERSATION_TO_INBOX": "До email-інбоксу можна перемістити лише email-розмови та розмови з вебчату, вебчат — лише якщо контакт має адресу електронної пошти. Інакше розмова не переміщується, натомість додається особиста нотатка.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Починає нову розмову з контактом у вибраному інбоксі електронної пошти, надсилає йому повідомлення електронною поштою та позначає розмову як вирішену. Це відбувається щоразу, коли спрацьовує правило. Якщо контакт не має адреси електронної пошти, нічого не надсилається, а натомість додається приватна нотатка.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Починає нову розмову з контактом у вибраному SMS-інбоксі, надсилає йому повідомлення як SMS і позначає розмову як вирішену. Це відбувається щоразу, коли спрацьовує правило. Повідомлення — звичайний текст без вкладень. Якщо контакт не має номера телефону, нічого не надсилається, а натомість додається приватна нотатка."
    },
    "NOTICES": {
      "AI_PROMPT": "Кожна окрема оцінка тарифікується.",
      "INCOMING_MESSAGES_COUNT": "Це стосується кількості вхідних повідомлень у розмові.",
      "OUTGOING_MESSAGES_COUNT": "Це стосується кількості вихідних повідомлень у розмові."
    },
    "PHASE": {
      "BEFORE_LABELING": "До маркування",
      "AFTER_LABELING": "Після маркування"
    },
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Вхідне повідомлення",
      "OUTGOING": "Вихідне повідомлення",
      "PRIVATE": "Приватна нотатка",
      "AI_SUMMARY": "Зведення ШІ"
    },
    "YES_NO_VALUES": {
      "YES": "Так",
      "NO": "Ні"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Особисте повідомлення в Instagram",
      "FACEBOOK_COMMENT": "Коментар у Facebook"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Розмову створено",
      "CONVERSATION_UPDATED": "Розмову оновлено",
      "MESSAGE_CREATED": "Повідомлення створено",
      "CONVERSATION_OPENED": "Розмову відкрито",
      "CONVERSATION_RESOLVED": "Розмову вирішено",
      "PHONE_CALL_FINISHED": "Дзвінок завершено"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Призначити агенту",
      "ASSIGN_TEAM": "Призначити команду",
      "ADD_LABEL": "Додати мітку",
      "REMOVE_LABEL": "Видалити мітку",
      "SEND_EMAIL_TO_TEAM": "Надіслати email команді",
      "SEND_EMAIL_TRANSCRIPT": "Надіслати стенограму електронною поштою",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Надіслати детальну стенограму електронною поштою",
      "MUTE_CONVERSATION": "Вимкнути сповіщення розмови",
      "SNOOZE_CONVERSATION": "Відкласти розмову",
      "RESOLVE_CONVERSATION": "Вирішити розмову",
      "OPEN_CONVERSATION": "Відкрити розмову",
      "SEND_WEBHOOK_EVENT": "Надіслати подію webhook",
      "SEND_ATTACHMENT": "Надіслати вкладення",
      "SEND_MESSAGE": "Надіслати повідомлення",
      "ADD_NOTE": "Додати нотатку",
      "CHANGE_PRIORITY": "Змінити пріоритет",
      "ADD_SLA": "Додати SLA",
      "SKIP_AUTO_PRIORITY": "Пропустити автопріоритет",
      "SKIP_AUTO_LABELING": "Пропустити автомаркування",
      "AUTO_TRANSLATE": "Перекласти повідомлення",
      "AUTO_TRANSLATE_CONVERSATION": "Перекласти розмову",
      "MOVE_CONVERSATION_TO_INBOX": "Перемістити розмову до інбоксу",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Надіслати повідомлення в новій розмові",
      "SEND_SMS_IN_NEW_CONVERSATION": "Надіслати SMS у новій розмові",
      "STOP_PROCESSING_RULES": "Припинити обробку правил"
    },
    "ATTRIBUTES": {
      "EXTENSION": "Викликаний внутрішній номер",
      "AI_FILTER": "Фільтр ШІ",
      "MESSAGE_TYPE": "Тип повідомлення",
      "MESSAGE_CONTAINS": "Вміст повідомлення",
      "EMAIL": "Email",
      "INBOX": "Інбокс",
      "CHANNEL_TYPE": "Тип інбоксу",
      "CONVERSATION_LANGUAGE": "Мова розмови",
      "PHONE_NUMBER": "Номер телефону",
      "STATUS": "Статус",
      "BROWSER_LANGUAGE": "Мова браузера",
      "MAIL_SUBJECT": "Тема email",
      "COUNTRY_NAME": "Країна",
      "MARKETPLACE_COUNTRY": "Країна маркетплейсу",
      "REFERER_LINK": "Реферальне посилання",
      "ASSIGNEE_NAME": "Призначений",
      "TEAM_NAME": "Команда",
      "PRIORITY": "Пріоритет",
      "CALL_DIRECTION": "Напрямок виклику",
      "MISSED_CALL": "Пропущений виклик",
      "MISSED_CALL_COUNT": "Кількість пропущених викликів",
      "MESSAGE_SOURCE_TYPE": "Тип джерела повідомлення",
      "INCOMING_MESSAGE_COUNT": "Кількість вхідних повідомлень",
      "OUTGOING_MESSAGE_COUNT": "Кількість вихідних повідомлень",
      "LABEL": "Мітка",
      "EMAIL_RECIPIENTS": "Отримувач email",
      "EMAIL_AUTO_REPLY": "Email є автоматичною відповіддю",
      "ATTACHMENT_EXTENSION": "Розширення вкладення",
      "WORKING_HOURS": "У робочий час",
      "AGENT_REPLIED": "Агент відповів після зміни статусу"
    },
    "WAIT": {
      "RUN_LABEL": "Виконати дії",
      "INSTANT": "Під час події",
      "DELAYED": "Із затримкою",
      "TRIGGER_LABEL": "Чекати, доки",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Розмова залишається в статусі",
        "CUSTOMER_UNRESPONSIVE": "Клієнт не відповідає агенту",
        "AGENT_UNRESPONSIVE": "Клієнт не отримує відповіді агента"
      },
      "STATUS_LABEL": "Статус",
      "STATUSES": {
        "OPEN": "Відкрита",
        "PENDING": "В очікуванні",
        "SNOOZED": "Відкладена",
        "RESOLVED": "Вирішена"
      },
      "DELAY_LABEL": "Час очікування",
      "DELAY_ERROR": "Введіть час очікування від 1 хвилини до 30 днів",
      "DURATION": {
        "MINUTES": "{count} хв",
        "HOURS": "{count} год",
        "DAYS": "{count} дн"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Дії виконуються, коли розмова перебуває в статусі {status} протягом {duration}. Зміна статусу до цього їх скасовує. Мітки, робочий час і відповіді агента перевіряються після завершення очікування.",
        "CUSTOMER_UNRESPONSIVE": "Дії виконуються, коли клієнт {duration} не відповідає на повідомлення агента. Відповідь клієнта їх скасовує; нове повідомлення агента перезапускає очікування.",
        "AGENT_UNRESPONSIVE": "Дії виконуються, коли клієнт чекає {duration} без відповіді агента. Відповідь агента їх скасовує."
      }
    }
  }
}
